import { ChevronLeft } from "lucide-react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useLocation, useNavigate } from "react-router-dom";
import CardPlanosMensaisResidenciais from "../components/Cards/CardPlanosMensaisResidenciais";
import CardPlanosTrimestraiResidenciais from "../components/Cards/CardPlanosTrimestraisResidenciais";
import { motion } from "framer-motion";

export default function VariedadeplanosEmpresariais() {
  const navigate = useNavigate();
  const location = useLocation();

  const propsCardPlanosEmpresariaisMensais = {
    descricao: "Planos Mensais",
  };

  const propsCardPlanosEmpresariaisTrimestrais = {
    descricao: "Planos Trimestrais",
  };

  const cards = [
    { component: CardPlanosMensaisResidenciais, props: propsCardPlanosEmpresariaisMensais, navigateTo: "/planosempresariais" },
    { component: CardPlanosTrimestraiResidenciais, props: propsCardPlanosEmpresariaisTrimestrais, navigateTo: "/planosempresariaistrimestrais" }
  ];

  return (
    <div className="flex h-screen justify-between flex-col font-questrial text-white">
      <div className="bg-blue-500 h-[34%] z-10 sticky top-0">
        <NavBar />
      </div>

      <div className="z-0 lg:z-20 lg:h-[50px] lg:w-[650px] md:w-[650px] sm:w-[540px] lg:-mt-[100px] flex flex-col sm:items-center mb-4 sm:flex-row justify-around items-center lg:items-center space-y-4 sm:space-y-0 sm:space-x-4 container mx-auto mt-8">

        <motion.button
          className="group flex absolute left-4 bottom-[76%]"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate(-1)}
        >
          <div className="flex md:flex lg:hidden">
            <div>
              <ChevronLeft className="group-hover:font-semibold text-black" />
            </div>
            <div>
              <span className="text-sm group-hover:font-semibold text-black">Voltar</span>
            </div>
          </div>
        </motion.button>

        {cards.map((card, index) => {
          const CardComponent = card.component;
          return (
            <motion.button
              key={index}
              onClick={() => navigate(`${card.navigateTo}${location.search}`)}
              className="w-[60%] sm:w-[48%] lg:w-[40%]"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <CardComponent {...card.props} />
            </motion.button>
          );
        })}

      </div>

      <div className="bg-blue-500 p-4 pb-2 font-extralight">
        <Footer />
      </div>
    </div>
  );
}
